import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Container, Panel, FieldSet, FormPanel, EmailField, Spacer, Label, Button, TextField } from '@sencha/ext-modern'

import { validateEmail } from '../public'
import { doForgetPassword } from 'tyan/reducers/actions'
import colors from '../components/colors'
import Logo from './Logo'
import Supplier from './Supplier'

Ext.require("Ext.data.validator.*");
const panelProps = {
  height: "100%",
  margin: '0 0 40 0'
}

class ForgetPassword extends React.Component {
  state = {
    userName: '',
    resetEmail: '',
    submitting: false,
    errorMessage: null,
    success: false,
    token: null,
  }

  componentDidMount() {
    this.source = new Ext.drag.Source({
      element: this.refs.dragItem.cmp.el,
      constrain: this.refs.dragContainer.cmp.el,
    });
  }

  componentWillUnmount() {
    Ext.destroy(this.source);
  }

  handleBack = () => {
    this.props.history.push('/')
  }

  handleSubmit = () => {
    const { userName, resetEmail } = this.state
    const { doForgetPassword } = this.props
    if (!resetEmail) {
      this.setState({
        errorMessage: resetEmail ? null : '请输入电子邮箱地址'
      })
      return
    }

    if (!validateEmail(resetEmail)) {
      this.setState({
        errorMessage: '请输入正确格式的电子邮箱地址'
      })
      return
    }

    doForgetPassword({
      userName, resetEmail,
      onRequest: () => {
        this.setState({ submitting: true })
      },
      onEnd: ({ errorMessage, token }) => {
        if (errorMessage) {
          this.setState({ submitting: false, errorMessage })
        } else {
          this.setState({ submitting: false, success: true, token })
        }
      }
    })
  }

  handleInput = (obj, value) => {
    const name = obj.getName()
    this.setState({ [name]: value, errorMessage: null })
  }

  handleKeyPress = () => {
    this.handleSubmit()
  }

  render() {
    const { errorMessage, submitting, success, token } = this.state
    return (
      <Panel shadow layout="fit" {...panelProps} >
        <Container layout={{ type: 'hbox', align: 'top', pack: "center" }} style={colors.card.grey} padding={Ext.os.is.Phone ? "20% 0 0 0" : "150 0 0 0"} ref="dragContainer">
          <FormPanel shadow ref="dragItem">
            <Spacer height="10" />
            <Logo title={success ? "发送成功！" : "忘记密码"} />
            <Spacer height="10" />
            <FieldSet title="" width={Ext.os.is.Phone ? "280" : "320"}>
              <Label html={success ? `我们已经成功发送一封密码重置的邮件给您，请根据邮件提示重置您的密码。`/* token(${token}) */ : "请输入您的电子邮件地址，我们会发送一封密码重置的邮件给您，您收到后请按照邮件内容中的提示进行操作。"} />
              {!success && <TextField label="用户名"
                name="userName"
                labelAlign="top"
                required
                placeholder="请输入用户名"
                requiredMessage="请输入用户名"
                onAction={this.handleKeyPress}
                onChange={this.handleInput} />}
              {!success && <EmailField label="Email"
                name="resetEmail"
                labelAlign="top"
                validators="email"
                required
                placeholder="请输入电子邮件地址"
                requiredMessage="请输入电子邮件地址"
                onAction={this.handleKeyPress}
                onChange={this.handleInput} />}
            </FieldSet>
            {errorMessage ? <Label html={errorMessage} style={{ color: 'red' }} /> : <Spacer height="20" />}
            <Container layout={{ type: 'vbox', align: 'middle', pack: 'space-around' }}>
              {!success && <Button
                ui="action raised"
                iconCls={submitting && "x-fa fa-spinner fa-pulse" || "x-fa fa-envelope-o"}
                text="发送"
                width='100%'
                handler={success ? this.handleBack : this.handleSubmit}
              />}
              <br />
              <Button
                iconCls="x-fa fa-arrow-left"
                text="返回"
                width='100%'
                handler={this.handleBack}
              />
            </Container>
            <Spacer height="20" />
            <Supplier />
            <Spacer height="20" />
          </FormPanel>
        </Container>
      </Panel>)
  }
}


export default compose(
  connect(null, { doForgetPassword }),
)(ForgetPassword)




